var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontMountains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3950.709,
    height: 841.255,
    viewBox: "0 0 3950.709 841.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80abbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366377"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M3948.6,651.9s-115.137-77.793-199.983-77.793-42.257-56.3-142.269-56.3-95.794,270.532-218.143,270.532c-110.365-2.745-76.319,271.964-213.377,271.964-53.315,0-74.361-48.756-170.825-48.756-89.636,0-106.708,77.117-200.707,77.117s-75.666-28.361-129.155-28.361-83.6-33.737-163.7-33.737c-88.836,0-110.657,84.921-224.71,84.921s-76.719-31.148-158.121-31.148c-74.581,0-66.294,54.8-158.251,54.8-47.265,0-112.236-161.386-202.17-161.386-47.484,0-84.316,62.944-127.807,62.944-68.5,0-54.751,74.792-113.367,74.792s-46.431-41.875-149.049-41.875c-40.329,0-67.021-116.741-205.96-116.741-143.554,0-137.811,92.717-208,92.717-117.989,0-103.05-239.779-178.6-239.779s-42.266,53.544-116.1,53.544c-65.593,0-76.682,74.818-123.363,74.818-108.39,0-83.427-296.879-175.882-296.879s-91.821-117.318-156.41-117.318c-47.324-.684-37.79,23.64-86.914,23.64S-2.109,304.737-2.109,304.737l0,837.649s209.764-7.533,608.533,0,1135.379.923,1135.379.923l2206.795,1.95Z",
    transform: "translate(2.109 -304.737)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontMountains);
export default __webpack_public_path__ + "static/media/front_mountains.8745c5fcb24a2902efc9cfb4850e9c4a.svg";
export { ForwardRef as ReactComponent };